import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  cs: {
    // App
    'app.title': 'GreenCAD software',
    'app.subtitle': 'Návrh elektroinstalací a smart home',

    // Pages
    'pages.floor': 'Patro',
    'pages.floorplan': 'Pudorys (kresleni)',
    'pages.situation': 'Situace',
    'pages.schema': 'Schema rozvaděče',
    'pages.cover': 'Hlavní desky',
    'pages.contents': 'Obsah',
    'pages.legend': 'Legenda',
    'pages.notes': 'Pozn\u00e1mky',
    'pages.vykaz_vymer': 'Výkaz výměr',
    'pages.technicka_zprava': 'Technická zpráva',
    'pages.room_table': 'Tabulka místností',
    'pages.label_config': 'Editor číslování',
    'pages.print_layout': 'Rozvržení tisku',
    'pages.newFloor': 'Nové patro',
    'pages.newSituation': 'Nová situace',
    'pages.newSchema': 'Nov\u00e9 sch\u00e9ma',
    'pages.newCover': 'Nové hlavní desky',
    'pages.newContents': 'Nový obsah',
    'pages.newLegend': 'Nová legenda',
    'pages.newNotes': 'Nov\u00e9 pozn\u00e1mky',
    'pages.deleteConfirm': 'Opravdu chcete smazat tuto stránku?',
    'pages.switching': 'Přepínám stránku...',
    'pages.created': 'Stránka vytvořena',
    'pages.deleted': 'Stránka smazána',
    'pages.renamed': 'Stránka přejmenována',

    // Cover Page
    'cover.title': 'Hlavní desky',
    'cover.save': 'Uložit',
    'cover.projectName': 'Název projektu',
    'cover.actionName': 'Název akce',
    'cover.clientName': 'Investor',
    'cover.clientAddress': 'Adresa',
    'cover.technicianNumber': 'Číslo ČKAIT',
    'cover.technicianName': 'Projektant',
    'cover.dateCreated': 'Datum vytvoření',
    'cover.dateRevision': 'Datum revize',
    'cover.buildingType': 'Typ stavby',
    'cover.stage': 'Stupeň PD',

    // Contents Page
    'contents.title': 'Obsah',
    'contents.pageName': 'Název',
    'contents.pageType': 'Typ',
    'contents.autoGenerated': 'Obsah je generován automaticky ze seznamu stránek',

    // Project List
    'projects.importDxf': 'Importovat DXF',
    'projects.newProject': 'Nový projekt',
    'projects.createTitle': 'Vytvořit nový projekt',
    'projects.nameLabel': 'Název projektu',
    'projects.namePlaceholder': 'Byt 3B - Elektroinstalace',
    'projects.descLabel': 'Popis',
    'projects.descPlaceholder': 'Půdorys elektroinstalace',
    'projects.cancel': 'Zrušit',
    'projects.create': 'Vytvořit',
    'projects.noProjects': 'Žádné projekty',
    'projects.noProjectsDesc': 'Vytvořte nový projekt nebo importujte DXF soubor s půdorysem pro začátek návrhu elektroinstalace.',
    'projects.noDescription': 'Bez popisu',
    'projects.layers': 'vrstev',
    'projects.elements': 'prvků',
    'projects.deleteConfirm': 'Opravdu chcete smazat tento projekt?',
    'projects.created': 'Projekt vytvořen',
    'projects.deleted': 'Projekt smazán',
    'projects.renamed': 'Projekt přejmenován',
    'projects.loadError': 'Nepodařilo se načíst projekty',
    'projects.uploadingDxf': 'Nahrávám DXF soubor...',
    'projects.dxfImported': 'DXF úspěšně importován',
    'projects.importedFromDxf': 'Importováno z DXF',
    'projects.clone': 'Klonovat projekt',
    'projects.cloned': 'Projekt naklonován',
    'projects.pages': 'stránek',
    'projects.stampConfigured': 'Razítko',
    'projects.importFromBackup': 'Import ze zálohy',
    'projects.cloneWithData': 'Klonovat s daty',
    'projects.cloneWithoutData': 'Klonovat bez dat (jen layout)',
    'projects.downloadBackup': 'Stáhnout zálohu',
    'projects.actions': 'Akce',
    'projects.rename': 'Přejmenovat',
    'projects.delete': 'Smazat',

    // Toolbar
    'toolbar.file': 'Soubor',
    'toolbar.fileTooltip': 'Soubor - Import / Export',
    'toolbar.importExport': 'Import / Export',
    'toolbar.importWizard': 'Průvodce importem',

    // DXF Import Dialog
    'dxfImport.title': 'Import DXF s výběrem vrstev',
    'dxfImport.step1': 'Vyberte DXF soubor',
    'dxfImport.step2': 'Vyberte vrstvy k importu',
    'dxfImport.analyzing': 'Analyzuji DXF soubor...',
    'dxfImport.dropHint': 'Klikněte pro výběr DXF souboru',
    'dxfImport.layersSelected': 'vrstev',
    'dxfImport.entities': 'entit',
    'dxfImport.outliers': 'mimo rozsah',
    'dxfImport.selectAll': 'Vybrat vše',
    'dxfImport.hideOutliers': 'Skrýt prvky mimo rozsah',
    'dxfImport.cancel': 'Zrušit',
    'dxfImport.back': 'Zpět',
    'dxfImport.import': 'Importovat',
    'toolbar.settings': 'Nastavení',
    'toolbar.settingsTooltip': 'Nastavení zobrazení a uchopení',
    'toolbar.controls': 'Prvky',
    'toolbar.controlsTooltip': 'Ovládací prvky a nástroje',
    'toolbar.placement': 'Umístění',
    'toolbar.numbering': 'Číslování',
    'toolbar.editing': 'Editace',
    'toolbar.clearLabels': 'Smazat čísla',
    'toolbar.measure': 'Měření',
    'toolbar.dxfSettings': 'Nastavení DXF',

    // Backup
    'toolbar.backup': 'Záloha',
    'toolbar.backupDownload': 'Stáhnout zálohu',
    'toolbar.backupImport': 'Import ze zálohy',
    'toolbar.exportAllPdf': 'PDF celý projekt',
    'backup.importing': 'Importuji zálohu...',
    'backup.imported': 'Záloha importována jako nový projekt',

    // Settings
    'toolbar.displaySettings': 'Zobrazení',
    'toolbar.projectSettings': 'Projekt',
    'settings.stampSettings': 'Nastavení razítka',
    'toolbar.back': 'Zpět',
    'toolbar.untitled': 'Bez názvu',
    'toolbar.select': 'Výběr (V)',
    'toolbar.pan': 'Posun (H)',
    'toolbar.text': 'Text (T)',
    'toolbar.comment': 'Komentář',
    'toolbar.trim': 'Ořez',
    'toolbar.line': 'Čára (L)',
    'toolbar.rectangle': 'Obdélník (R)',
    'toolbar.undo': 'Zpět (Ctrl+Z)',
    'toolbar.flipLabels': 'Překlopit',
    'toolbar.flipLabelsTooltip': 'Překlopit popisky na opačnou stranu',
    'toolbar.editGeometry': 'Upravit půdorys',
    'geometryEditor.title': 'Editor půdorysu',
    'geometryEditor.searchLayers': 'Hledat vrstvu...',
    'geometryEditor.selected': 'vybráno',
    'geometryEditor.delete': 'Smazat',
    'geometryEditor.classify': 'Klasifikovat jako:',
    'geometryEditor.lineWeight': 'Tloušťka:',
    'geometryEditor.selectAll': 'Vše',
    'toolbar.redo': 'Vpřed (Ctrl+Y)',
    'toolbar.importDxf': 'Import DXF',
    'toolbar.importDxfTooltip': 'Importovat DXF půdorys',
    'toolbar.replaceDxf': 'Nahradit DXF',
    'toolbar.replaceDxfTooltip': 'Nahradit půdorys novým DXF (prvky zůstanou)',
    'toolbar.dxfReplaced': 'DXF nahrazen. Prvky zachovány.',
    'toolbar.autoplace': 'Rozmístit',
    'toolbar.autoplaceTooltip': 'Automatické rozmístění zásuvek podél stěn',
    'toolbar.autonumber': 'Číslovat',
    'toolbar.autonumberTooltip': 'Automatické číslování prvků',
    'toolbar.validate': 'AI Kontrola',
    'toolbar.validating': 'Kontrola...',
    'toolbar.validateTooltip': 'AI kontrola rozmístění dle ČSN 33 2130',
    'toolbar.aiAutoplace': 'AI Rozmístění',
    'toolbar.aiAutoplaceTooltip': 'Inteligentní rozmístění prvků - detekce stěn, dveří, oken',
    'toolbar.export': 'Export',
    'toolbar.exportFile': 'Export souboru',
    'toolbar.exportDxf': 'Export DXF',
    'toolbar.pdfPreview': 'Náhled PDF',
    'export.pdfTitle': 'Export do PDF',
    'export.paper': 'Formát papíru',
    'export.legend': 'Legenda',
    'export.stamp': 'Razítko',
    'export.colorMode': 'Barevně',
    'export.bwMode': 'Černobíle',
    'export.stampSettings': 'Údaje razítka',
    'export.author': 'Vypracoval',
    'export.drawingName': 'Název výkresu',
    'export.drawingNumber': 'Číslo výkresu',
    'export.scale': 'Měřítko',
    'export.revision': 'Revize',
    'export.exportPdf': 'Exportovat PDF',
    'toolbar.elementReport': 'Výkaz prvků',
    'toolbar.excelXlsx': 'Excel (.xlsx)',
    'toolbar.csv': 'CSV',
    'toolbar.snaps': 'Magnety',
    'toolbar.snapsTooltip': 'Přichytávání (F1-F5)',
    'toolbar.symbolSize': 'Velikost značek',
    'toolbar.lineThickness': 'Tloušťka čar',
    'toolbar.symbolScale': 'Velikost symbolů',
    'toolbar.textSize': 'Velikost textu',

    // Left Sidebar
    'sidebar.toolbox': 'Nástroje',
    'sidebar.layers': 'Vrstvy',
    'sidebar.history': 'Historie',
    'sidebar.historySteps': 'kroků',
    'sidebar.historyHint': 'Klikněte pro návrat',
    'sidebar.historyStep': 'Krok',
    'sidebar.noHistory': 'Žádná historie',
    'sidebar.toolboxHint': 'Klikněte na prvek a pak na plátno pro umístění',
    'sidebar.addLayer': 'Přidat vrstvu',
    'sidebar.layerName': 'Název vrstvy',
    'sidebar.layerNamePlaceholder': 'Název vrstvy',
    'sidebar.layerColor': 'Barva',
    'sidebar.layerType': 'Typ',
    'sidebar.noLayers': 'Žádné vrstvy',
    'sidebar.layerAdded': 'Vrstva přidána',
    'sidebar.layerDeleted': 'Vrstva smazána',
    'sidebar.elements': 'prvků',
    'sidebar.layersCount': 'vrstev',
    'sidebar.lineThickness': 'Tloušťka čar',
    'sidebar.customColor': 'Vlastní barva',

    // Categories
    'category.outlet': 'Zásuvky',
    'category.light': 'Světla',
    'category.switch': 'Vypínače',
    'category.low_voltage': 'Slaboproud',
    'category.smart_home': 'Smart Home',
    'category.loxone_tree': 'Loxone Tree',
    'category.loxone_air': 'Loxone Air',
    'category.loxone_sensors': 'Loxone Senzory',
    'category.av_multimedia': 'AV / Multimédia',
    'category.security': 'Zabezpečení',
    'category.lightning_protection': 'Hromosvod',
    'category.furniture': 'Nábytek',
    'category.custom': 'Vlastní',

    // Settings
    'settings.defaultSymbols': 'Výchozí symboly',
    'settings.defaultSymbolsHint': 'Vyberte výchozí typ prvku pro každou kategorii. Při otevření kategorie se automaticky vybere.',
    'settings.noDefault': '(žádný)',
    'common.cancel': 'Zrušit',
    'common.save': 'Uložit',

    // Symbol Manager
    'symbolManager.manage': 'Správa symbolů',
    'symbolManager.title': 'Správa symbolů',
    'symbolManager.addNew': 'Přidat nový',
    'symbolManager.manageExisting': 'Existující',
    'symbolManager.name': 'Název symbolu',
    'symbolManager.category': 'Kategorie',
    'symbolManager.icon': 'Ikona',
    'symbolManager.color': 'Barva',
    'symbolManager.size': 'Velikost',
    'symbolManager.save': 'Uložit symbol',
    'symbolManager.noCustom': 'Žádné vlastní symboly',
    'symbolManager.deleteConfirm': 'Smazat tento symbol?',
    'symbolManager.editBuiltin': 'Upravit výchozí',

    // Backup
    'backup.title': 'Stáhnout zálohu',
    'backup.description': 'Vyberte, co chcete zálohovat:',
    'backup.fullProject': 'Celý projekt',
    'backup.allPages': 'všechny stránky a data',
    'backup.currentPage': 'Pouze aktuální stránku',
    'backup.importing': 'Importuji zálohu...',
    'backup.imported': 'Záloha importována jako nový projekt',

    // Pages
    'pages.duplicate': 'Duplikovat stránku',
    'pages.duplicated': 'Stránka duplikována',
    'pages.cloneToProject': 'Klonovat do projektu',
    'pages.cloneDescription': 'Vyberte cílový projekt pro stránku',
    'pages.cloned': 'Stránka naklonována do',
    'pages.noOtherProjects': 'Žádné další projekty',
    'pages.pagesCount': 'stránek',
    'pages.cloneConfirm': 'Klonovat',
    'pages.cloneLayoutOnly': 'Jen layout',
    'pages.cloneWithData': 'S daty',
    'pages.delete': 'Smazat stránku',

    // Stamp
    'stamp.author': 'Projektant',
    'stamp.clientName': 'Investor',
    'stamp.clientAddress': 'Adresa investora',
    'stamp.technicianNumber': 'Číslo ČKAIT',
    'stamp.drawingName': 'Název výkresu',
    'stamp.drawingNumber': 'Číslo výkresu',
    'stamp.scale': 'Měřítko',
    'stamp.revision': 'Revize',
    'stamp.dateCreated': 'Datum',
    'stamp.description': 'Tato data se použijí pro razítko v PDF exportu.',
    'settings.stampSettings': 'Nastavení razítka',
    'settings.stampSaved': 'Nastavení razítka uloženo',

    // Export
    'export.exportScope': 'Rozsah exportu',
    'export.currentPage': 'Aktuální stránka',
    'export.allPages': 'Všechny stránky',
    'export.preview': 'Náhled',

    // Right Sidebar
    'properties.title': 'Vlastnosti',
    'properties.validation': 'Kontrola',
    'properties.clone': 'Klonovat',
    'properties.delete': 'Smazat',
    'properties.position': 'Pozice',
    'properties.rotation': 'Rotace (°)',
    'properties.layer': 'Vrstva',
    'properties.info': 'Informace',
    'properties.type': 'Typ',
    'properties.layerName': 'Vrstva',
    'properties.id': 'ID',
    'properties.parameters': 'Parametry',
    'properties.noSelection': 'Vyberte prvek pro zobrazení vlastností',
    'properties.noSelectionHint': 'Klikněte na prvek na plátně',
    'properties.colorOverride': 'Barva prvku',
    'properties.strokeOverride': 'Tloušťka čáry',
    'properties.layerDefault': '(výchozí z vrstvy)',
    'properties.labelConfig': 'Popisek',
    'properties.labelText': 'Text popisku',
    'properties.labelPosition': 'Pozice popisku',
    'properties.labelFontScale': 'Velikost písma',
    'properties.posRight': 'Vpravo',
    'properties.posLeft': 'Vlevo',
    'properties.posAbove': 'Nahoře',
    'properties.posBelow': 'Dole',
    'properties.posAuto': 'Automatická',
    'properties.posFront': 'Na čele symbolu',
    'properties.labelGap': 'Vzdálenost od symbolu',

    // Validation
    'validation.results': 'Výsledky kontroly',
    'validation.running': 'Probíhá AI kontrola...',
    'validation.runningHint': 'Kontrola dle ČSN 33 2130 / ČSN 33 2000',
    'validation.pass': 'V pořádku',
    'validation.findings': 'nálezů',
    'validation.standard': 'Norma',
    'validation.noValidation': 'Zatím nebyla spuštěna kontrola',
    'validation.noValidationHint': "Klikněte na 'AI Kontrola' v panelu nástrojů",
    'validation.error': 'Chyba',
    'validation.warning': 'Varování',
    'validation.info': 'Info',

    // Status Bar
    'status.grid': 'Mřížka',
    'status.elements': 'Prvky',
    'status.dxfEntities': 'DXF entity',
    'status.tool.select': 'Výběr',
    'status.tool.pan': 'Posun',
    'status.tool.place': 'Umístění',
    'status.tool.text': 'Text',
    'status.tool.line': 'Čára',
    'status.tool.rectangle': 'Obdélník',

    // Canvas
    'canvas.noFloorPlan': 'Žádný půdorys načten',
    'canvas.importHint': 'Importujte DXF soubor pro začátek',

    // Editor
    'editor.loading': 'Načítám projekt...',
    'editor.loadError': 'Nepodařilo se načíst projekt',
    'editor.uploadingDxf': 'Nahrávám DXF soubor...',
    'editor.dxfUploaded': 'DXF úspěšně nahrán',
    'editor.autoPlacing': 'Automatické rozmisťování zásuvek...',
    'editor.autoPlaced': 'Umístěno {count} zásuvek',
    'editor.autoNumbering': 'Automatické číslování prvků...',
    'editor.autoNumbered': 'Očíslováno {count} prvků',
    'editor.aiCheck': 'Spouštím AI kontrolu...',
    'editor.aiCheckPass': 'Kontrola prošla v pořádku!',
    'editor.aiCheckFindings': 'Nalezeno {count} nálezů',
    'editor.elementDeleted': 'Prvek smazán',
    'editor.elementCloned': 'Prvek naklonován',
    'editor.undone': 'Zpět',
    'editor.redone': 'Vpřed',
    'editor.labelsFlipped': 'Popisky překlopeny',
    'editor.pivotRotated': 'Prvky osově otočeny o {degrees}°',
    'editor.duplicatedRight': 'Duplikováno doprava',
    'editor.duplicatedLeft': 'Duplikováno doleva',
    'editor.selectedSameType': 'Vybráno {count} prvků stejného typu',
    'editor.otherPages': 'Na dalších stránkách',
    'editor.numberedSelected': 'Očíslováno {count} vybraných prvků',
    'editor.aiPlacing': 'AI rozmisťování prvků...',
    'editor.aiPlaced': 'AI umístilo {count} prvků ({outlets} zásuvek, {switches} vypínačů, {lights} světel)',
    'editor.aiPlacedFull': 'AI umístilo {count} prvků: {outlets} zásuvek, {switches} vypínačů, {lights} světel, {blinds} žaluzií, {magnets} magnetů',

    // Context menu
    'context.select': 'Vybrat',
    'context.clone': 'Klonovat',
    'context.delete': 'Smazat',
    'context.rotateCw': 'Otočit o 90° doprava',
    'context.rotateCcw': 'Otočit o 90° doleva',
    'context.pivotRotateCw': 'Otočit o 90° osově (CW)',
    'context.pivotRotateCcw': 'Otočit o 90° osově (CCW)',
    'context.rotate45cw': 'Otočit o 45° doprava',
    'context.rotate45ccw': 'Otočit o 45° doleva',
    'context.bringToFront': 'Do popředí',
    'context.sendToBack': 'Do pozadí',
    'context.properties': 'Vlastnosti',
    'context.placeHere': 'Umístit prvek sem',
    'context.scaleUp': 'Zvětšit (1.5x)',
    'context.scaleDown': 'Zmenšit (0.75x)',
    'context.selectSameType': 'Vybrat stejný typ',
    'context.autoNumberSelected': 'Očíslovat vybrané',
    'context.duplicateRight': 'Duplikovat doprava',
    'context.duplicateLeft': 'Duplikovat doleva',
    'context.copy': 'Kop\u00edrovat',
    'context.placeAlongDrawing': 'Rozmístit prvky podél tvaru',
    'context.paste': 'Vlo\u017eit',
    'context.copied': 'prvk\u016f zkop\u00edrov\u00e1no',
    'context.pasted': 'prvk\u016f vlo\u017eeno',
    'context.quickAdd': 'Rychle p\u0159idat prvek',
    'context.quickAddSearch': 'Hledat prvek...',
    'context.noResults': '\u017d\u00e1dn\u00e9 v\u00fdsledky',

    // Snap modes
    'snap.edge': 'Hrana',
    'snap.center': 'Střed',
    'snap.corner': 'Roh',
    'snap.axis': 'Osa',
    'snap.rightAngle': 'Pravý úhel',
    'snap.edgeDesc': 'Přichytávání k hraně stěny (F1)',
    'snap.centerDesc': 'Přichytávání ke středu stěny (F2)',
    'snap.cornerDesc': 'Přichytávání k rohu stěn (F3)',
    'snap.axisDesc': 'Zamknutí na osu X/Y (F4)',
    'snap.rightAngleDesc': 'Omezení na pravé úhly (F5)',
    'snap.enabled': 'Magnet zapnut:',
    'snap.disabled': 'Magnetismus vypnut',
    'snap.ortho': 'Ortho',
    'snap.orthoDesc': 'Kreslení v pravém úhlu (F6)',
    'snap.grid': 'Mřížka (F7)',
    'snap.gridDesc': 'Přichytávání k neviditelné mřížce (F7)',
    'snap.element': 'Prvek (F8)',
    'snap.elementDesc': 'Přichytávání k okolním prvkům (F8)',
    'snap.smartGuides': 'Osy (F9)',
    'snap.smartGuidesDesc': 'Vodící osy zarovnání s okolními prvky',
    'snap.elementGap': 'Mezera mezi prvky',

    // Alignment
    'align.title': 'Zarovnání',
    'align.left': 'Zarovnat vlevo',
    'align.right': 'Zarovnat vpravo',
    'align.top': 'Zarovnat nahoru',
    'align.bottom': 'Zarovnat dolů',
    'align.centerH': 'Střed horizontálně',
    'align.centerV': 'Střed vertikálně',
    'align.distributeH': 'Rozestupy H',
    'align.distributeV': 'Rozestupy V',

    // Numbering dialog
    'numberDialog.title': 'Pokročilé číslování',
    'numberDialog.selectedOnly': 'Pouze vybrané prvky',
    'numberDialog.elementsSelected': 'prvků vybráno',
    'numberDialog.elementsTotal': 'prvků celkem',
    'numberDialog.style': 'Styl číslování',
    'numberDialog.defaultPrefix': 'Výchozí zkratka/prefix',
    'numberDialog.typeOverrides': 'Prefix dle typu prvku',
    'numberDialog.startFrom': 'Začít od čísla',
    'numberDialog.useRoom': 'Přidat označení místnosti',
    'numberDialog.sortDirection': 'Směr číslování',
    'numberDialog.leftToRight': 'Zleva doprava',
    'numberDialog.topToBottom': 'Shora dolů',
    'numberDialog.labelPosition': 'Pozice textu',
    'numberDialog.posBelow': 'Pod symbolem',
    'numberDialog.posAbove': 'Nad symbolem',
    'numberDialog.posLeft': 'Vlevo',
    'numberDialog.posRight': 'Vpravo',
    'numberDialog.posAuto': 'Automatická',
    'numberDialog.posFront': 'Na čele symbolu',
    'numberDialog.labelGap': 'Vzdálenost od symbolu',
    'numberDialog.labelGapHint': '0 = výchozí vzdálenost',
    'numberDialog.fontSize': 'Velikost textu',
    'numberDialog.preview': 'Náhled',
    'numberDialog.willBeNumbered': 'prvků bude očíslováno',
    'numberDialog.cancel': 'Zrušit',
    'numberDialog.apply': 'Aplikovat',

    // Place along drawing
    'placeAlongDrawing.title': 'Prvky podél tvaru',
    'placeAlongDrawing.elementType': 'Typ prvku',
    'placeAlongDrawing.selectType': 'Vyberte typ prvku...',
    'placeAlongDrawing.count': 'Počet prvků',
    'placeAlongDrawing.spacing': 'Rozestupy',
    'placeAlongDrawing.useSpacing': 'Použít pevné rozestupy',
    'placeAlongDrawing.willBePlaced': 'prvků bude umístěno',
    'placeAlongDrawing.apply': 'Umístit',
    'placeAlongDrawing.contextAction': 'Prvky podél tvaru',
    'placeAlongDrawing.alignMode': 'Zarovnání prvků',
    'placeAlongDrawing.alignTangent': 'Na osu (tečna)',
    'placeAlongDrawing.alignEdge': 'Na hranu (kolmo)',
    'placeAlongDrawing.rotationOffset': 'Otočení prvků',
    'placeAlong.rotationOffset': 'Dodatečné otočení',
    'placeAlong.alignMode': 'Zarovnání prvků',
    'placeAlong.alignTangent': 'Na osu (tečna)',
    'placeAlong.alignEdge': 'Na hranu (kolmo)',

    // Place Along
    'placeAlong.title': 'Vložit prvky podél tvaru',
    'placeAlong.shape': 'Tvar',
    'placeAlong.line': 'Čára',
    'placeAlong.circle': 'Kružnice',
    'placeAlong.ellipse': 'Elipsa',
    'placeAlong.rectangle': 'Obdélník',
    'placeAlong.element': 'Prvek k vložení',
    'placeAlong.searchElement': 'Hledat prvek...',
    'placeAlong.distribution': 'Rozložení',
    'placeAlong.byCount': 'Podle počtu',
    'placeAlong.bySpacing': 'Podle rozestupu',
    'placeAlong.count': 'Počet',
    'placeAlong.spacing': 'Rozestup',
    'placeAlong.alignToPath': 'Otočit prvky podél trasy',
    'placeAlong.start': 'Nakreslit tvar',
    'placeAlong.hintLine': 'Klikněte 2 body na plátně pro definování čáry',
    'placeAlong.hintCircle': 'Klikněte střed, pak bod na obvodu',
    'placeAlong.hintEllipse': 'Klikněte střed, pak bod pro poloosu',
    'placeAlong.hintRect': 'Klikněte 2 rohy obdélníku',
    'placeAlong.placed': 'Umístěno {count} prvků podél tvaru',
    'placeAlong.drawShape': 'Nakreslete tvar na plátně...',
    'placeAlong.clickFirst': 'Klikněte první bod...',
    'placeAlong.clickSecond': 'Klikněte druhý bod...',
    'placeAlong.toolbar': 'Podél tvaru',
    'placeAlong.toolbarTooltip': 'Vložit prvky podél čáry/kruhu/obdélníku',

    // LED Strip
    'toolbar.ledStrip': 'LED pásek',
    'toolbar.ledStripTooltip': 'Nakreslit LED pásek (2 body)',
    'ledStrip.title': 'LED Pásek',
    'ledStrip.placed': 'LED pásek vytvořen',
    'ledStrip.hint': 'Klikněte 2 body pro nakreslení LED pásku',
    'ledStrip.clickFirst': 'Klikněte počáteční bod LED pásku...',
    'ledStrip.clickSecond': 'Klikněte koncový bod LED pásku...',
    'status.tool.ledStrip': 'LED pásek',
    'status.tool.polyline': 'Lomená čára',
    'status.tool.circle': 'Kružnice',
    'status.tool.ellipse': 'Elipsa',

    // New drawing tools
    'toolbar.polyline': 'Lomená čára (P)',
    'toolbar.circle': 'Kružnice (C)',
    'toolbar.ellipse': 'Elipsa',
    'editor.polylineHint': 'Klikejte body, dvojklik pro ukončení',
    'editor.circleHint': 'Klikněte střed, pak bod na obvodu',
    'editor.ellipseHint': 'Klikněte střed, pak protilehlý roh',
    'editor.rotatePreview': 'R = otočit náhled',
    'properties.multiEdit': '{count} prvků vybráno',
    'properties.different': 'rozdílné',
    'properties.applyToAll': 'Použít na všechny',
    'properties.multiEditHint': 'Změna se aplikuje na všechny vybrané',
    'shortcuts.title': 'Klávesové zkratky',

    // Rooms
    'rooms.title': 'Definice místností',
    'rooms.description': 'Definujte místnosti a jejich typ pro chytré rozmístění prvků',
    'rooms.room': 'Místnost',
    'rooms.addRoom': 'Přidat místnost',
    'rooms.importAuto': 'Importovat detekované',
    'rooms.noRooms': 'Zatím žádné místnosti. Přidejte nebo importujte automaticky detekované.',
    'rooms.save': 'Uložit místnosti',
    'rooms.saveAndPlace': 'Uložit a rozmístit prvky',
    'rooms.placing': 'Rozmisťování...',
    'rooms.walls': 'Stěny',
    'rooms.partitions': 'Příčky',
    'rooms.doors': 'Dveře',
    'rooms.windows': 'Okna',
    'rooms.defineRooms': 'Místnosti & AI',
    'rooms.defineRoomsTooltip': 'Definovat místnosti a spustit AI rozmístění',
    'rooms.defineRoomTool': 'Definovat místnost',
    'rooms.clickToDefine': 'Klikněte dovnitř místnosti pro automatickou detekci hranic',
    'rooms.selectType': 'Zvolte typ místnosti',
    'rooms.noRoomDetected': 'Místnost nenalezena - zkuste kliknout dovnitř jiné místnosti',
    'rooms.roomDefined': 'Místnost "{name}" definována',
    'rooms.type.kitchen': 'Kuchyň',
    'rooms.type.living_room': 'Obývák',
    'rooms.type.bedroom': 'Ložnice',
    'rooms.type.bathroom': 'Koupelna',
    'rooms.type.hallway': 'Chodba',
    'rooms.type.office': 'Pracovna',
    'rooms.type.default': 'Ostatní',
    'rooms.type.children': 'Dětský pokoj',
    'rooms.type.children_1': 'Dětský pokoj 1',
    'rooms.type.children_2': 'Dětský pokoj 2',
    'rooms.type.children_3': 'Dětský pokoj 3',
    'rooms.type.wc': 'WC',
    'rooms.type.storage': 'Komora',
    'rooms.type.pantry': 'Spíž',
    'rooms.type.laundry': 'Prádelna',
    'rooms.type.garage': 'Garáž',
    'rooms.type.technical': 'Technická místnost',
    'rooms.type.dining': 'Jídelna',
    'rooms.type.entrance': 'Vstupní hala',
    'rooms.type.balcony': 'Balkón',
    'rooms.type.terrace': 'Terasa',
    'rooms.type.veranda': 'Veranda',
    'rooms.type.wardrobe': 'Šatna',
    'rooms.type.boiler_room': 'Kotelna',
    'rooms.type.staircase': 'Schodiště',
    'rooms.type.cellar': 'Sklep',
    'rooms.type.attic': 'Půda',
    'rooms.type.workshop': 'Dílna',
    'rooms.type.guest_room': 'Pokoj pro hosty',
    'rooms.type.other': 'Ostatní',
    'rooms.type.custom': 'Vlastní',

    // Block Editor
    'blockEditor.title': 'Nový symbol',
    'blockEditor.editTitle': 'Upravit symbol',
    'blockEditor.description': 'Nakreslete vlastní symbol pomocí čar, kruhů a obdélníků',
    'blockEditor.name': 'Název',
    'blockEditor.namePlaceholder': 'např. Můj symbol...',
    'blockEditor.category': 'Kategorie',
    'blockEditor.color': 'Barva',
    'blockEditor.stroke': 'Tloušťka',
    'blockEditor.shapes': 'tvarů',
    'blockEditor.save': 'Uložit symbol',
    'blockEditor.openEditor': 'Block Editor',
    'blockEditor.openEditorTooltip': 'Vytvořit nebo upravit vlastní symbol',

    // Language
    'lang.cs': 'Čeština',
    'lang.en': 'English',
  },
  en: {
    // App
    'app.title': 'GreenCAD software',
    'app.subtitle': 'Electrical installation & smart home design',

    // Pages
    'pages.floor': 'Floor',
    'pages.floorplan': 'Floor Plan (drawing)',
    'pages.situation': 'Situation',
    'pages.schema': 'Distribution Board Schema',
    'pages.cover': 'Cover Pages',
    'pages.contents': 'Contents',
    'pages.legend': 'Legend',
    'pages.notes': 'Notes',
    'pages.vykaz_vymer': 'Bill of Quantities',
    'pages.technicka_zprava': 'Technical Report',
    'pages.room_table': 'Room Table',
    'pages.newFloor': 'New Floor',
    'pages.newSituation': 'New Situation',
    'pages.newSchema': 'New Schema',
    'pages.newCover': 'New Cover Pages',
    'pages.newContents': 'New Contents',
    'pages.newLegend': 'New Legend',
    'pages.newNotes': 'New Notes',
    'pages.deleteConfirm': 'Are you sure you want to delete this page?',
    'pages.switching': 'Switching page...',
    'pages.created': 'Page created',
    'pages.deleted': 'Page deleted',
    'pages.renamed': 'Page renamed',

    // Cover Page
    'cover.title': 'Cover Pages',
    'cover.save': 'Save',
    'cover.projectName': 'Project Name',
    'cover.actionName': 'Action Name',
    'cover.clientName': 'Client',
    'cover.clientAddress': 'Address',
    'cover.technicianNumber': 'ČKAIT Number',
    'cover.technicianName': 'Designer',
    'cover.dateCreated': 'Date Created',
    'cover.dateRevision': 'Revision Date',
    'cover.buildingType': 'Building Type',
    'cover.stage': 'PD Stage',

    // Contents Page
    'contents.title': 'Contents',
    'contents.pageName': 'Name',
    'contents.pageType': 'Type',
    'contents.autoGenerated': 'Contents are auto-generated from the page list',

    // Project List
    'projects.importDxf': 'Import DXF',
    'projects.newProject': 'New Project',
    'projects.createTitle': 'Create New Project',
    'projects.nameLabel': 'Project Name',
    'projects.namePlaceholder': 'Apartment 3B - Electrical',
    'projects.descLabel': 'Description',
    'projects.descPlaceholder': 'Electrical installation layout',
    'projects.cancel': 'Cancel',
    'projects.create': 'Create',
    'projects.noProjects': 'No Projects',
    'projects.noProjectsDesc': 'Create a new project or import a DXF floor plan to begin designing your electrical installation.',
    'projects.noDescription': 'No description',
    'projects.layers': 'layers',
    'projects.elements': 'elements',
    'projects.deleteConfirm': 'Are you sure you want to delete this project?',
    'projects.created': 'Project created',
    'projects.deleted': 'Project deleted',
    'projects.renamed': 'Project renamed',
    'projects.loadError': 'Failed to load projects',
    'projects.uploadingDxf': 'Uploading DXF file...',
    'projects.dxfImported': 'DXF imported successfully',
    'projects.importedFromDxf': 'Imported from DXF',
    'projects.clone': 'Clone project',
    'projects.cloned': 'Project cloned',
    'projects.pages': 'pages',
    'projects.stampConfigured': 'Stamp',
    'projects.importFromBackup': 'Import from backup',
    'projects.cloneWithData': 'Clone with data',
    'projects.cloneWithoutData': 'Clone without data (layout only)',
    'projects.downloadBackup': 'Download backup',
    'projects.actions': 'Actions',
    'projects.rename': 'Rename',
    'projects.delete': 'Delete',

    // Toolbar
    'toolbar.file': 'File',
    'toolbar.fileTooltip': 'File - Import / Export',
    'toolbar.importExport': 'Import / Export',
    'toolbar.importWizard': 'Import Wizard',

    // DXF Import Dialog
    'dxfImport.title': 'DXF Import with Layer Selection',
    'dxfImport.step1': 'Select DXF file',
    'dxfImport.step2': 'Select layers to import',
    'dxfImport.analyzing': 'Analyzing DXF file...',
    'dxfImport.dropHint': 'Click to select DXF file',
    'dxfImport.layersSelected': 'layers',
    'dxfImport.entities': 'entities',
    'dxfImport.outliers': 'out of range',
    'dxfImport.selectAll': 'Select all',
    'dxfImport.hideOutliers': 'Hide out-of-range elements',
    'dxfImport.cancel': 'Cancel',
    'dxfImport.back': 'Back',
    'dxfImport.import': 'Import',
    'toolbar.settings': 'Settings',
    'toolbar.settingsTooltip': 'Display & snap settings',
    'toolbar.controls': 'Tools',
    'toolbar.controlsTooltip': 'Controls and tools',
    'toolbar.placement': 'Placement',
    'toolbar.numbering': 'Numbering',
    'toolbar.editing': 'Editing',
    'toolbar.clearLabels': 'Clear numbers',
    'toolbar.measure': 'Measure',
    'toolbar.dxfSettings': 'DXF Settings',

    // Backup
    'toolbar.backup': 'Backup',
    'toolbar.backupDownload': 'Download backup',
    'toolbar.backupImport': 'Import from backup',
    'toolbar.exportAllPdf': 'PDF entire project',
    'backup.importing': 'Importing backup...',
    'backup.imported': 'Backup imported as new project',

    // Settings
    'toolbar.displaySettings': 'Display',
    'toolbar.projectSettings': 'Project',
    'settings.stampSettings': 'Stamp settings',
    'toolbar.back': 'Back',
    'toolbar.untitled': 'Untitled',
    'toolbar.select': 'Select (V)',
    'toolbar.pan': 'Pan (H)',
    'toolbar.text': 'Text (T)',
    'toolbar.comment': 'Comment',
    'toolbar.trim': 'Trim',
    'toolbar.line': 'Line (L)',
    'toolbar.rectangle': 'Rectangle (R)',
    'toolbar.undo': 'Undo (Ctrl+Z)',
    'toolbar.flipLabels': 'Flip labels',
    'toolbar.flipLabelsTooltip': 'Flip all labels to opposite side',
    'toolbar.editGeometry': 'Edit floor plan',
    'geometryEditor.title': 'Floor Plan Editor',
    'geometryEditor.searchLayers': 'Search layer...',
    'geometryEditor.selected': 'selected',
    'geometryEditor.delete': 'Delete',
    'geometryEditor.classify': 'Classify as:',
    'geometryEditor.lineWeight': 'Weight:',
    'geometryEditor.selectAll': 'All',
    'toolbar.redo': 'Redo (Ctrl+Y)',
    'toolbar.importDxf': 'Import DXF',
    'toolbar.importDxfTooltip': 'Import DXF floor plan',
    'toolbar.replaceDxf': 'Replace DXF',
    'toolbar.replaceDxfTooltip': 'Replace floor plan with new DXF (elements stay)',
    'toolbar.dxfReplaced': 'DXF replaced. Elements preserved.',
    'toolbar.autoplace': 'Auto-Place',
    'toolbar.autoplaceTooltip': 'Automatic socket placement along walls',
    'toolbar.autonumber': 'Number',
    'toolbar.autonumberTooltip': 'Automatic element numbering',
    'toolbar.validate': 'AI Check',
    'toolbar.validating': 'Checking...',
    'toolbar.validateTooltip': 'AI validation per ČSN 33 2130',
    'toolbar.aiAutoplace': 'AI Place',
    'toolbar.aiAutoplaceTooltip': 'Smart placement - detects walls, doors, windows',
    'toolbar.export': 'Export',
    'toolbar.exportFile': 'Export File',
    'toolbar.exportDxf': 'Export DXF',
    'toolbar.pdfPreview': 'PDF Preview',
    'export.pdfTitle': 'Export to PDF',
    'export.paper': 'Paper format',
    'export.legend': 'Legend',
    'export.stamp': 'Title block',
    'export.colorMode': 'Color',
    'export.bwMode': 'Black & White',
    'export.stampSettings': 'Title block settings',
    'export.author': 'Author',
    'export.drawingName': 'Drawing name',
    'export.drawingNumber': 'Drawing number',
    'export.scale': 'Scale',
    'export.revision': 'Revision',
    'export.exportPdf': 'Export PDF',
    'toolbar.elementReport': 'Element Report',
    'toolbar.excelXlsx': 'Excel (.xlsx)',
    'toolbar.csv': 'CSV',
    'toolbar.snaps': 'Snaps',
    'toolbar.snapsTooltip': 'Snap settings (F1-F5)',
    'toolbar.symbolSize': 'Symbol size',
    'toolbar.lineThickness': 'Line thickness',
    'toolbar.symbolScale': 'Symbol scale',
    'toolbar.textSize': 'Text size',

    // Left Sidebar
    'sidebar.toolbox': 'Toolbox',
    'sidebar.layers': 'Layers',
    'sidebar.history': 'History',
    'sidebar.historySteps': 'steps',
    'sidebar.historyHint': 'Click to jump back',
    'sidebar.historyStep': 'Step',
    'sidebar.noHistory': 'No history',
    'sidebar.toolboxHint': 'Click on an element, then on the canvas to place it',
    'sidebar.addLayer': 'Add Layer',
    'sidebar.layerName': 'Layer Name',
    'sidebar.layerNamePlaceholder': 'Layer name',
    'sidebar.layerColor': 'Color',
    'sidebar.layerType': 'Type',
    'sidebar.noLayers': 'No layers',
    'sidebar.layerAdded': 'Layer added',
    'sidebar.layerDeleted': 'Layer deleted',
    'sidebar.elements': 'elements',
    'sidebar.layersCount': 'layers',
    'sidebar.lineThickness': 'Line thickness',
    'sidebar.customColor': 'Custom color',

    // Categories
    'category.outlet': 'Sockets',
    'category.light': 'Lights',
    'category.switch': 'Switches',
    'category.low_voltage': 'Low Voltage',
    'category.smart_home': 'Smart Home',
    'category.loxone_tree': 'Loxone Tree',
    'category.loxone_air': 'Loxone Air',
    'category.loxone_sensors': 'Loxone Sensors',
    'category.av_multimedia': 'AV / Multimedia',
    'category.security': 'Security',
    'category.lightning_protection': 'Lightning Protection',
    'category.furniture': 'Furniture',
    'category.custom': 'Custom',

    // Settings
    'settings.defaultSymbols': 'Default symbols',
    'settings.defaultSymbolsHint': 'Choose default element type for each category. It will be auto-selected when opening the category.',
    'settings.noDefault': '(none)',
    'common.cancel': 'Cancel',
    'common.save': 'Save',

    // Symbol Manager
    'symbolManager.manage': 'Manage Symbols',
    'symbolManager.title': 'Symbol Manager',
    'symbolManager.addNew': 'Add New',
    'symbolManager.manageExisting': 'Existing',
    'symbolManager.name': 'Symbol Name',
    'symbolManager.category': 'Category',
    'symbolManager.icon': 'Icon',
    'symbolManager.color': 'Color',
    'symbolManager.size': 'Size',
    'symbolManager.save': 'Save Symbol',
    'symbolManager.noCustom': 'No custom symbols',
    'symbolManager.deleteConfirm': 'Delete this symbol?',
    'symbolManager.editBuiltin': 'Edit defaults',

    // Right Sidebar
    'properties.title': 'Properties',
    'properties.validation': 'Validation',
    'properties.clone': 'Clone',
    'properties.delete': 'Delete',
    'properties.position': 'Position',
    'properties.rotation': 'Rotation (°)',
    'properties.layer': 'Layer',
    'properties.info': 'Information',
    'properties.type': 'Type',
    'properties.layerName': 'Layer',
    'properties.id': 'ID',
    'properties.parameters': 'Parameters',
    'properties.noSelection': 'Select an element to view properties',
    'properties.noSelectionHint': 'Click on an element on the canvas',
    'properties.colorOverride': 'Element color',
    'properties.strokeOverride': 'Stroke width',
    'properties.layerDefault': '(layer default)',
    'properties.labelConfig': 'Label',
    'properties.labelText': 'Label text',
    'properties.labelPosition': 'Label position',
    'properties.labelFontScale': 'Font scale',
    'properties.posRight': 'Right',
    'properties.posLeft': 'Left',
    'properties.posAbove': 'Above',
    'properties.posBelow': 'Below',
    'properties.posAuto': 'Automatic',
    'properties.posFront': 'At symbol front',
    'properties.labelGap': 'Distance from symbol',

    // Validation
    'validation.results': 'Validation Results',
    'validation.running': 'Running AI validation...',
    'validation.runningHint': 'Checking per ČSN 33 2130 / ČSN 33 2000',
    'validation.pass': 'All OK',
    'validation.findings': 'findings',
    'validation.standard': 'Standard',
    'validation.noValidation': 'No validation run yet',
    'validation.noValidationHint': "Click 'AI Check' in the toolbar",
    'validation.error': 'Error',
    'validation.warning': 'Warning',
    'validation.info': 'Info',

    // Status Bar
    'status.grid': 'Grid',
    'status.elements': 'Elements',
    'status.dxfEntities': 'DXF entities',
    'status.tool.select': 'Select',
    'status.tool.pan': 'Pan',
    'status.tool.place': 'Place',
    'status.tool.text': 'Text',
    'status.tool.line': 'Line',
    'status.tool.rectangle': 'Rectangle',

    // Canvas
    'canvas.noFloorPlan': 'No floor plan loaded',
    'canvas.importHint': 'Import a DXF file to get started',

    // Editor
    'editor.loading': 'Loading project...',
    'editor.loadError': 'Failed to load project',
    'editor.uploadingDxf': 'Uploading DXF file...',
    'editor.dxfUploaded': 'DXF uploaded successfully',
    'editor.autoPlacing': 'Auto-placing sockets...',
    'editor.autoPlaced': '{count} sockets placed',
    'editor.autoNumbering': 'Auto-numbering elements...',
    'editor.autoNumbered': '{count} elements numbered',
    'editor.aiCheck': 'Running AI check...',
    'editor.aiCheckPass': 'Validation passed!',
    'editor.aiCheckFindings': 'Found {count} findings',
    'editor.elementDeleted': 'Element deleted',
    'editor.elementCloned': 'Element cloned',
    'editor.undone': 'Undo',
    'editor.redone': 'Redo',
    'editor.labelsFlipped': 'Labels flipped',
    'editor.pivotRotated': 'Elements pivot rotated by {degrees}°',
    'editor.duplicatedRight': 'Duplicated to the right',
    'editor.duplicatedLeft': 'Duplicated to the left',
    'editor.selectedSameType': 'Selected {count} elements of same type',
    'editor.otherPages': 'On other pages',
    'editor.numberedSelected': 'Numbered {count} selected elements',
    'editor.aiPlacing': 'AI smart placement...',
    'editor.aiPlaced': 'AI placed {count} elements ({outlets} outlets, {switches} switches, {lights} lights)',
    'editor.aiPlacedFull': 'AI placed {count} elements: {outlets} outlets, {switches} switches, {lights} lights, {blinds} blinds, {magnets} magnets',

    // Context menu
    'context.select': 'Select',
    'context.clone': 'Clone',
    'context.delete': 'Delete',
    'context.rotateCw': 'Rotate 90° CW',
    'context.rotateCcw': 'Rotate 90° CCW',
    'context.pivotRotateCw': 'Pivot rotate 90° CW',
    'context.pivotRotateCcw': 'Pivot rotate 90° CCW',
    'context.rotate45cw': 'Rotate 45° CW',
    'context.rotate45ccw': 'Rotate 45° CCW',
    'context.bringToFront': 'Bring to Front',
    'context.sendToBack': 'Send to Back',
    'context.properties': 'Properties',
    'context.placeHere': 'Place element here',
    'context.scaleUp': 'Scale up (1.5x)',
    'context.scaleDown': 'Scale down (0.75x)',
    'context.selectSameType': 'Select same type',
    'context.autoNumberSelected': 'Number selected',
    'context.duplicateRight': 'Duplicate right',
    'context.duplicateLeft': 'Duplicate left',
    'context.copy': 'Copy',
    'context.placeAlongDrawing': 'Place elements along shape',
    'context.paste': 'Paste',
    'context.copied': 'elements copied',
    'context.pasted': 'elements pasted',
    'context.quickAdd': 'Quick add element',
    'context.quickAddSearch': 'Search element...',
    'context.noResults': 'No results',

    // Snap modes
    'snap.edge': 'Edge',
    'snap.center': 'Center',
    'snap.corner': 'Corner',
    'snap.axis': 'Axis',
    'snap.rightAngle': 'Right angle',
    'snap.edgeDesc': 'Snap to wall edge (F1)',
    'snap.centerDesc': 'Snap to wall center (F2)',
    'snap.cornerDesc': 'Snap to wall corners (F3)',
    'snap.axisDesc': 'Lock to X/Y axis (F4)',
    'snap.rightAngleDesc': 'Constrain to right angles (F5)',
    'snap.enabled': 'Snap enabled:',
    'snap.disabled': 'Snapping disabled',
    'snap.ortho': 'Ortho',
    'snap.orthoDesc': 'Draw at right angles (F6)',
    'snap.grid': 'Grid (F7)',
    'snap.gridDesc': 'Snap to invisible grid (F7)',
    'snap.element': 'Element (F8)',
    'snap.elementDesc': 'Snap to nearby elements (F8)',
    'snap.smartGuides': 'Guides (F9)',
    'snap.smartGuidesDesc': 'Alignment guide axes with nearby elements',
    'snap.elementGap': 'Gap between elements',

    // Alignment
    'align.title': 'Alignment',
    'align.left': 'Align left',
    'align.right': 'Align right',
    'align.top': 'Align top',
    'align.bottom': 'Align bottom',
    'align.centerH': 'Center horizontal',
    'align.centerV': 'Center vertical',
    'align.distributeH': 'Distribute H',
    'align.distributeV': 'Distribute V',

    // Numbering dialog
    'numberDialog.title': 'Advanced numbering',
    'numberDialog.selectedOnly': 'Selected elements only',
    'numberDialog.elementsSelected': 'elements selected',
    'numberDialog.elementsTotal': 'elements total',
    'numberDialog.style': 'Numbering style',
    'numberDialog.defaultPrefix': 'Default prefix',
    'numberDialog.typeOverrides': 'Prefix per element type',
    'numberDialog.startFrom': 'Start from number',
    'numberDialog.useRoom': 'Add room designation',
    'numberDialog.sortDirection': 'Numbering direction',
    'numberDialog.leftToRight': 'Left to right',
    'numberDialog.topToBottom': 'Top to bottom',
    'numberDialog.labelPosition': 'Label position',
    'numberDialog.posBelow': 'Below symbol',
    'numberDialog.posAbove': 'Above symbol',
    'numberDialog.posLeft': 'Left',
    'numberDialog.posRight': 'Right',
    'numberDialog.posAuto': 'Automatic',
    'numberDialog.posFront': 'At symbol front',
    'numberDialog.labelGap': 'Distance from symbol',
    'numberDialog.labelGapHint': '0 = default distance',
    'numberDialog.fontSize': 'Text size',
    'numberDialog.preview': 'Preview',
    'numberDialog.willBeNumbered': 'elements will be numbered',
    'numberDialog.cancel': 'Cancel',
    'numberDialog.apply': 'Apply',

    // Place along drawing
    'placeAlongDrawing.title': 'Elements along shape',
    'placeAlongDrawing.elementType': 'Element type',
    'placeAlongDrawing.selectType': 'Select element type...',
    'placeAlongDrawing.count': 'Number of elements',
    'placeAlongDrawing.spacing': 'Spacing',
    'placeAlongDrawing.useSpacing': 'Use fixed spacing',
    'placeAlongDrawing.willBePlaced': 'elements will be placed',
    'placeAlongDrawing.apply': 'Place',
    'placeAlongDrawing.contextAction': 'Elements along shape',
    'placeAlongDrawing.alignMode': 'Element alignment',
    'placeAlongDrawing.alignTangent': 'Along axis (tangent)',
    'placeAlongDrawing.alignEdge': 'To edge (perpendicular)',
    'placeAlongDrawing.rotationOffset': 'Rotation offset',
    'placeAlong.rotationOffset': 'Additional rotation',
    'placeAlong.alignMode': 'Element alignment',
    'placeAlong.alignTangent': 'Along axis (tangent)',
    'placeAlong.alignEdge': 'To edge (perpendicular)',

    // Place Along
    'placeAlong.title': 'Place elements along shape',
    'placeAlong.shape': 'Shape',
    'placeAlong.line': 'Line',
    'placeAlong.circle': 'Circle',
    'placeAlong.ellipse': 'Ellipse',
    'placeAlong.rectangle': 'Rectangle',
    'placeAlong.element': 'Element to place',
    'placeAlong.searchElement': 'Search element...',
    'placeAlong.distribution': 'Distribution',
    'placeAlong.byCount': 'By count',
    'placeAlong.bySpacing': 'By spacing',
    'placeAlong.count': 'Count',
    'placeAlong.spacing': 'Spacing',
    'placeAlong.alignToPath': 'Align elements to path',
    'placeAlong.start': 'Draw shape',
    'placeAlong.hintLine': 'Click 2 points on canvas to define a line',
    'placeAlong.hintCircle': 'Click center, then a point on circumference',
    'placeAlong.hintEllipse': 'Click center, then a point for semi-axis',
    'placeAlong.hintRect': 'Click 2 corners of rectangle',
    'placeAlong.placed': '{count} elements placed along shape',
    'placeAlong.drawShape': 'Draw shape on canvas...',
    'placeAlong.clickFirst': 'Click first point...',
    'placeAlong.clickSecond': 'Click second point...',
    'placeAlong.toolbar': 'Along shape',
    'placeAlong.toolbarTooltip': 'Place elements along line/circle/rectangle',

    // LED Strip
    'toolbar.ledStrip': 'LED strip',
    'toolbar.ledStripTooltip': 'Draw LED strip (2 points)',
    'ledStrip.title': 'LED Strip',
    'ledStrip.placed': 'LED strip created',
    'ledStrip.hint': 'Click 2 points to draw LED strip',
    'ledStrip.clickFirst': 'Click start point of LED strip...',
    'ledStrip.clickSecond': 'Click end point of LED strip...',
    'status.tool.ledStrip': 'LED strip',
    'status.tool.polyline': 'Polyline',
    'status.tool.circle': 'Circle',
    'status.tool.ellipse': 'Ellipse',

    // New drawing tools
    'toolbar.polyline': 'Polyline (P)',
    'toolbar.circle': 'Circle (C)',
    'toolbar.ellipse': 'Ellipse',
    'editor.polylineHint': 'Click points, double-click to finish',
    'editor.circleHint': 'Click center, then edge point',
    'editor.ellipseHint': 'Click center, then opposite corner',
    'editor.rotatePreview': 'R = rotate preview',
    'properties.multiEdit': '{count} elements selected',
    'properties.different': 'different',
    'properties.applyToAll': 'Apply to all',
    'properties.multiEditHint': 'Changing a value applies to all selected',
    'shortcuts.title': 'Keyboard shortcuts',

    // Rooms
    'rooms.title': 'Room Definition',
    'rooms.description': 'Define rooms and their type for smart element placement',
    'rooms.room': 'Room',
    'rooms.addRoom': 'Add room',
    'rooms.importAuto': 'Import detected',
    'rooms.noRooms': 'No rooms yet. Add or import auto-detected ones.',
    'rooms.save': 'Save rooms',
    'rooms.saveAndPlace': 'Save & Place elements',
    'rooms.placing': 'Placing...',
    'rooms.walls': 'Walls',
    'rooms.partitions': 'Partitions',
    'rooms.doors': 'Doors',
    'rooms.windows': 'Windows',
    'rooms.defineRooms': 'Rooms & AI',
    'rooms.defineRoomsTooltip': 'Define rooms and run AI placement',
    'rooms.defineRoomTool': 'Define room',
    'rooms.clickToDefine': 'Click inside a room to auto-detect its boundaries',
    'rooms.selectType': 'Select room type',
    'rooms.noRoomDetected': 'No room found - try clicking inside another room',
    'rooms.roomDefined': 'Room "{name}" defined',
    'rooms.type.kitchen': 'Kitchen',
    'rooms.type.living_room': 'Living room',
    'rooms.type.bedroom': 'Bedroom',
    'rooms.type.bathroom': 'Bathroom',
    'rooms.type.hallway': 'Hallway',
    'rooms.type.office': 'Office',
    'rooms.type.default': 'Other',
    'rooms.type.children': 'Children room',
    'rooms.type.children_1': 'Children room 1',
    'rooms.type.children_2': 'Children room 2',
    'rooms.type.children_3': 'Children room 3',
    'rooms.type.wc': 'WC',
    'rooms.type.storage': 'Storage',
    'rooms.type.pantry': 'Pantry',
    'rooms.type.laundry': 'Laundry',
    'rooms.type.garage': 'Garage',
    'rooms.type.technical': 'Technical room',
    'rooms.type.dining': 'Dining room',
    'rooms.type.entrance': 'Entrance hall',
    'rooms.type.custom': 'Custom',

    // Block Editor
    'blockEditor.title': 'New symbol',
    'blockEditor.editTitle': 'Edit symbol',
    'blockEditor.description': 'Draw a custom symbol using lines, circles and rectangles',
    'blockEditor.name': 'Name',
    'blockEditor.namePlaceholder': 'e.g. My symbol...',
    'blockEditor.category': 'Category',
    'blockEditor.color': 'Color',
    'blockEditor.stroke': 'Stroke',
    'blockEditor.shapes': 'shapes',
    'blockEditor.save': 'Save symbol',
    'blockEditor.openEditor': 'Block Editor',
    'blockEditor.openEditorTooltip': 'Create or edit a custom symbol',

    // Language
    'lang.cs': 'Čeština',
    'lang.en': 'English',
  }
};

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    const saved = localStorage.getItem('elektrocad-lang');
    return saved || 'cs';
  });

  const changeLocale = useCallback((newLocale) => {
    setLocale(newLocale);
    localStorage.setItem('elektrocad-lang', newLocale);
  }, []);

  const t = useCallback((key, params = {}) => {
    let str = translations[locale]?.[key] || translations['cs']?.[key] || key;
    Object.entries(params).forEach(([k, v]) => {
      str = str.replace(`{${k}}`, v);
    });
    return str;
  }, [locale]);

  return (
    <I18nContext.Provider value={{ locale, setLocale: changeLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
